import styled from "styled-components";
import { FlexDiv } from "../../../components/Atoms";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

export const Wrapper = styled(FlexDiv)`
  justify-content: flex-end;
  width: 50%;
  // margin: 40px 0px 64px;
  @media only screen and (max-width: 1079px) {
    width: 100%;
    margin: unset;
    // padding: 0 16px 100px;
  }
  @media only screen and (max-width: 600px) {
    margin: 0px auto;
  }
`;

export const LeftSection = styled(FlexDiv)`
  width: 630px;
  flex-direction: column;
  gap: 32px;
  @media only screen and (max-width: 1079px) {
    max-width: unset;
  }
`;

export const BottomHeading = styled(Typography)`
  font-family: var(--man-700);
  font-size: 32px;
  line-height: 43.71px;
  color: ${theme.colorsV2.shyft.purple_text};
`;
